export function OutlineCalendarioDeCampanasIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.8029 20.0542H4.9065C3.86053 20.0542 3.01465 19.2084 3.01465 18.1624V9.63086H20.0686V15.3155"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.80322 15.7891V17.6855"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M16.2805 12V13.8964"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M4.9065 4.89648H18.1768C19.2227 4.89648 20.0686 5.74236 20.0686 6.78834V9.63521H3.01465V6.78834C3.01465 5.74236 3.86053 4.89648 4.9065 4.89648Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M6.80298 6.78825V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M16.2803 6.78825V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M19.7593 20.1052L17.158 20.0961L15.0387 20.087L10.7866 20.0733L12.6012 14.6934L19.7593 20.1052Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.906 13.7969L10.4866 20.9686"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0638 19.209L19.459 21.0008"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
